"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = exports.getChildren = exports.Tab = exports.TabContent = exports.TabPanel = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('Tabs'), recompose_1.pure);
var TabPanel = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: 'sok-tab-panel' }, children));
};
exports.TabPanel = TabPanel;
var TabContent = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: 'sok-tab-content' }, children));
};
exports.TabContent = TabContent;
var Tab = function (activeIndex, onClick, children, index) { return (React.createElement("div", { key: index, className: classNames('sok-tab', activeIndex === index ? 'active' : null), onClick: function () { return onClick(index); } }, children)); };
exports.Tab = Tab;
var getChildren = function (children, activeIndex) {
    if (activeIndex !== null &&
        activeIndex !== undefined &&
        activeIndex > -1 &&
        activeIndex < children.length / 2) {
        var index = Math.floor(children.length / 2) + activeIndex;
        return children[index];
    }
    return undefined;
};
exports.getChildren = getChildren;
exports.Tabs = enhance(function (_a) {
    var activeIndex = _a.activeIndex, onClick = _a.onClick, className = _a.className, children = _a.children;
    return (React.createElement("div", { className: classNames('sok-tabs', className) },
        React.createElement(exports.TabContent, null, children
            .slice(0, Math.floor(children.length / 2))
            .filter(function (content) { return !!content; })
            .map(function (content, index) { return (0, exports.Tab)(activeIndex, onClick, content, index); })),
        React.createElement(exports.TabPanel, null, (0, exports.getChildren)(children, activeIndex))));
});
//# sourceMappingURL=index.js.map